import { render, staticRenderFns } from "./preview-editor.vue?vue&type=template&id=163aa73c&scoped=true"
import script from "./preview-editor.vue?vue&type=script&lang=js"
export * from "./preview-editor.vue?vue&type=script&lang=js"
import style0 from "./preview-editor.vue?vue&type=style&index=0&id=163aa73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aa73c",
  null
  
)

export default component.exports